import axios from "axios";
import { urlCoreBack } from "../../project/configs/config";
import "../utils/axios.interceptor";
//
// #############################################################################
//
export const getArmazonesAnteojosSol = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Armazones y Anteojos de Sol";

  if (params.tipoArticulo) {
    _params.tipo_articulo = params.tipoArticulo;
  }

  if (params.codigo) {
    _params.codigo = params.codigo;
  }

  if (params.descripcion) {
    _params.descripcion = params.descripcion;
  }

  if (params.arAsMarca) {
    _params.id_ar_as_marca = params.arAsMarca;
  }

  if (params.arAsModelo) {
    _params.modelo = params.arAsModelo;
  }

  if (params.arAsCategoria) {
    _params.id_ar_as_categoria = params.arAsCategoria;
  }

  if (params.arAsMaterial) {
    _params.id_ar_as_material = params.arAsMaterial;
  }

  if (params.arAsFormato) {
    _params.id_ar_as_formato = params.arAsFormato;
  }

  if (params.arAsCalibre) {
    _params.id_ar_as_calibre = params.arAsCalibre;
  }

  if (params.arAsTipo) {
    _params.id_ar_as_tipo = params.arAsTipo;
  }

  if (params.disponibleObraSocial) {
    _params.disponible_obra_social = params.disponibleObraSocial;
  }

  if ("precioVentaDesde" in params) {
    _params.precio_venta_desde = params.precioVentaDesde;
  }

  if ("precioVentaHasta" in params) {
    _params.precio_venta_hasta = params.precioVentaHasta;
  }

  if (params.rows !== undefined) {
    _params.rows = params.rows;
  }

  if (params.first !== undefined) {
    _params.first = params.first;
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/articulo/armazon-anteojo-sol-search/`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getArmazonAnteojoSol = async (params) => {
  let _errorMessage = "Se produjo un error al obtener el Armazón o Anteojo de Sol";

  // console.log("---");
  // console.log("in articuloservice >> getArmazonAnteojoSol");
  // console.log("params");
  // console.log(params);
  // console.log();

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/articulo/armazon-anteojo-sol/`,
      params: params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      } else {
        if (response.data.code === "err-articulo-codigo-not-exist") {
          response.ok = false;
          response.messageText = "No existe un armazón o un anteojo de sol con el código dado";
          response.messageSeverity = "info";
        } else if (response.data.code === "err-articulo-not-existencia-disponible") {
          response.messageText = "Este armazón / anteojo de sol NO TIENE EXISTENCIA DISPONIBLE actualmente";
          response.messageSeverity = "error";
        }
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getCristales = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Cristales";

  if (params.anteojoCristalesTipoAnteojo) {
    _params.tipo_anteojo = params.anteojoCristalesTipoAnteojo;
  }

  if ("esfera" in params) {
    _params.esfera = params.esfera;
  }

  if ("cilindro" in params) {
    _params.cilindro = params.cilindro;
  }

  if ("adicion" in params) {
    _params.adicion = params.adicion;
  }

  if (params.descripcion) {
    _params.descripcion_cristal_producto = params.descripcion;
  }

  if (params.marca) {
    _params.id_bl_cr_marca = params.marca;
  }

  if (params.material) {
    _params.id_bl_cr_material = params.material;
  }

  if ("precioVentaDesde" in params) {
    _params.precio_venta_desde = params.precioVentaDesde;
  }

  if ("precioVentaHasta" in params) {
    _params.precio_venta_hasta = params.precioVentaHasta;
  }

  if (params.disponibleObraSocial) {
    _params.disponible_obra_social = params.disponibleObraSocial;
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/cristal-opcion/`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getAccesorios = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Accesorios";

  if (params.codigo) {
    _params.codigo = params.codigo;
  }

  if (params.descripcion) {
    _params.descripcion = params.descripcion;
  }

  if ("precioVentaDesde" in params) {
    _params.precio_venta_desde = params.precioVentaDesde;
  }

  if ("precioVentaHasta" in params) {
    _params.precio_venta_hasta = params.precioVentaHasta;
  }

  if (params.rows !== undefined) {
    _params.rows = params.rows;
  }

  if (params.first !== undefined) {
    _params.first = params.first;
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/articulo/accesorio-search/`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getProducto = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener el Producto";

  _params.codigo = params;

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/articulo/otro-producto/`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      } else {
        if (response.data.message_code === "err-articulo-codigo-not-exist") {
          response.ok = false;
          response.messageText =
            "No existe un Armazon, Anteojo de Sol, Lente de Contacto, Accesorio o Solución de Limpieza con el código dado";
          response.messageSeverity = "info";
          return response;
        }
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getSolucionesLimpieza = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Soluciones de Limpieza";

  if (params.codigo) {
    _params.codigo = params.codigo;
  }

  if (params.descripcion) {
    _params.descripcion = params.descripcion;
  }

  if (params.slMarca) {
    _params.id_sl_marca = params.slMarca;
  }

  if (params.slIndicacion) {
    _params.id_sl_indicacion = params.slIndicacion;
  }

  if ("precioVentaDesde" in params) {
    _params.precio_venta_desde = params.precioVentaDesde;
  }

  if ("precioVentaHasta" in params) {
    _params.precio_venta_hasta = params.precioVentaHasta;
  }

  if (params.rows !== undefined) {
    _params.rows = params.rows;
  }

  if (params.first !== undefined) {
    _params.first = params.first;
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/articulo/solucion-limpieza-search/`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getLentesDeContacto = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Soluciones de Limpieza";

  if (params.codigo) {
    _params.codigo = params.codigo;
  }

  if (params.descripcion) {
    _params.descripcion = params.descripcion;
  }

  if (params.lcMarca) {
    _params.id_lc_marca = params.lcMarca;
  }

  if (params.lcTiempoUso) {
    _params.id_lc_tiempo_uso = params.lcTiempoUso;
  }

  if ("lcEsfera" in params) {
    _params.esfera = params.lcEsfera;
  }

  if ("lcCilindro" in params) {
    _params.cilindro = params.lcCilindro;
  }

  if ("precioVentaDesde" in params) {
    _params.precio_venta_desde = params.precioVentaDesde;
  }

  if ("precioVentaHasta" in params) {
    _params.precio_venta_hasta = params.precioVentaHasta;
  }

  if (params.rows !== undefined) {
    _params.rows = params.rows;
  }

  if (params.first !== undefined) {
    _params.first = params.first;
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/articulo/lente-contacto-search/`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getPorcentajeDescuento = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener el porcentaje de descuento";

  _params.tipo_articulo = params.tipoArticulo;

  switch (_params.tipo_articulo) {
    case "armazon":
    case "anteojo_sol":
      _params.id_ar_as_marca = params.id;
      break;
    case "cristal":
      _params.id_cristal_producto = params.id;
      break;
    case "lente_contacto":
      _params.id_lente_contacto_producto = params.id;
      break;

    case "solucion_limpieza":
      _params.id_sl_marca = params.id;
      break;
    case "tratamiento":
      _params.id_tr_marca = params.id;
      break;
    default:
      break;
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/porcentaje-descuento/`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      } else {
        response.ok = false;
        response.messageText = _errorMessage;
        response.messageSeverity = "info";
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getCristalBlock = async (params) => {
  // let _params = {};
  let _errorMessage = "Se produjo un error al obtener el Cristal o Block";

  // console.log('---');
  // console.log('in ');
  // console.log('estoy en el servicio para traer cristal block');
  // console.log('params');
  // console.log(params);

  params.id_area = localStorage.getItem("id_area_deposito");

  // console.log('_params');
  // console.log(_params);


  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/articulo/cristal-block/`,
      params: params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      } else {
        response.ok = false;
        if (response.data.code === "err-articulo-codigo-not-exist") {
          response.messageText = "No existe un Cristal/Block con el código dado";
          response.messageSeverity = "warning";
        } else if (response.data.code === "err-articulo-not-existencia-disponible") {
          response.messageText = "Este Cristal/Block NO TIENE EXISTENCIA DISPONIBLE actualmente";
          response.messageSeverity = "error";
        }
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getArticuloData = async (params) => {
  let _errorMessage = "Se produjo un error al obtener el Artículo";

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/articulo/`,
      params: params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      } else {
        response.ok = false;
        if (response.data.code === "err-articulo-codigo-not-exist") {
          response.messageText = "No existe un artículo con el código dado";
          response.messageSeverity = "error";
        }
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getArticuloStock = async (params) => {
  let _errorMessage = "Se produjo un error al obtener el stock del Artículo";

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/stock-articulo/`,
      params: params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};